export * from './inaxConfigUi/index';